import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabase'
import Auth from './pages/Auth'
import Dashboard from './pages/Dashboard'
import Season from './pages/Season'
import Career from './pages/Career'
import Goals from './pages/Goals'
import Networking from './pages/Networking'
import Profile from './pages/Profile'
import Admin from './pages/Admin'
import ResetPassword from './pages/ResetPassword'
import Layout from './components/Layout'
import './index.css'

export default function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session)
      if ((event === 'SIGNED_IN' || event === 'INITIAL_SESSION') && session?.user?.id) {
        supabase.from('profiles').update({ last_seen_at: new Date().toISOString() }).eq('id', session.user.id)
      }
    })
    return () => subscription.unsubscribe()
  }, [])

  if (loading) return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#080806'}}>
      <div style={{fontFamily:'Bebas Neue',fontSize:32,letterSpacing:4,color:'#FDD700'}}>JNM</div>
    </div>
  )

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth" element={!session ? <Auth /> : <Navigate to="/" />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={session ? <Layout session={session} /> : <Navigate to="/auth" />}>
          <Route index element={<Dashboard session={session} />} />
          <Route path="season" element={<Season session={session} />} />
          <Route path="career" element={<Career session={session} />} />
          <Route path="goals" element={<Goals session={session} />} />
          <Route path="networking" element={<Networking session={session} />} />
          <Route path="profile" element={<Profile session={session} />} />
          <Route path="admin" element={<Admin session={session} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
